import { render, staticRenderFns } from "./AdminManageSMS.vue?vue&type=template&id=44f71070"
import script from "./AdminManageSMS.vue?vue&type=script&lang=js"
export * from "./AdminManageSMS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports